import { render, staticRenderFns } from "./SpcmStudentProfileBuildingReco.vue?vue&type=template&id=b7b3f5bc&lang=true"
import script from "./SpcmStudentProfileBuildingReco.vue?vue&type=script&lang=js"
export * from "./SpcmStudentProfileBuildingReco.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports